// subscriptionApis.js
import axios from 'axios';
import { baseURL } from './api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// ── Pricing & Plan Config ──────────────────────────────────────────────────

export async function getPlanConfig(planId) {
    const response = await axios.get(
        `${baseURL}pricing/configure/${planId}/`,
        { headers: getAuthHeaders() }
    );
    return response.data;
}

export async function getShowPlans() {
    const response = await axios.get(
        `${baseURL}show-plans/`,
        { headers: getAuthHeaders() }
    );
    return response.data;
}

export async function getUpgradePlans() {
    const response = await axios.get(
        `${baseURL}subscriptions/upgrade-plans/`,
        { headers: getAuthHeaders() }
    );
    return response.data;
}

// ── Subscription Management ────────────────────────────────────────────────

export async function getCurrentPlan() {
    const response = await axios.get(
        `${baseURL}subscriptions/current-plan/`,
        { headers: getAuthHeaders() }
    );
    return response.data;
}

export async function calculateUpgrade(planId, billingCycle) {
    const response = await axios.get(
        `${baseURL}subscriptions/calculate-upgrade/?plan_id=${planId}&billing_cycle=${billingCycle}`,
        { headers: getAuthHeaders() }
    );
    return response.data;
}

// ── Orders & Payments ──────────────────────────────────────────────────────

export async function createOrder(payload) {
    const response = await axios.post(
        `${baseURL}subscriptions/create-order/`,
        payload,
        { headers: getAuthHeaders() }
    );
    return response.data;
}

export async function verifyPayment(payload) {
    const response = await axios.post(
        `${baseURL}subscriptions/verify-payment/`,
        payload,
        { headers: getAuthHeaders() }
    );
    return response.data;
}